import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../services/app.service';
import { MultiLangPipe } from '../../pipes/multi-lang.pipe'

interface JumbotronConfig {
  title? : any;
  content? : any;
  bgColor? : string;
  titleTextColor? : string;
  contentTextColor? : string;
  mapping?: {
    titleKey?: string;
    contentKey?: string;
  }
  class?: string;
}
@Component({
  selector: 'app-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss']
})
export class JumbotronComponent implements OnInit {
  @Input() config : JumbotronConfig;
  @Input() data;
  class: string = '';
  constructor(private appService : AppService, private multiLangPipe: MultiLangPipe) { }
  /**
   * @task QLIKTAG-2943
   * @author Radhika Agnihotri
   */
  ngOnInit() {
    let path : Array<string>;

    if(this.config.hasOwnProperty('class')) {
      //set class to jumbotron
      this.class = this.config.class;
    }

    if(this.config.hasOwnProperty('mapping')) {

      //Resolve indexes in mapping -- @NEilC 4/4/2019
      this.config.mapping = this.appService.resolveIndex(this.config.mapping);

      //check if titleKey is present
      if(this.config.mapping.hasOwnProperty('titleKey')){
        path = this.config.mapping.titleKey.split('.');
        let title = this.appService.findObjectByPath(this.data, path);

        if(title) {
          this.config.title = title;
        }
       
      }
      //check if contentKey is present
      if(this.config.mapping.hasOwnProperty('contentKey')){
        path = this.config.mapping.contentKey.split('.');
        let content = this.appService.findObjectByPath(this.data, path);
        
        if(content) {
          this.config.content = content;
        }
      }
    }
    //console.log("this.config", this.config)
    if(this.config.title) {
      this.config.title = this.multiLangPipe.transform(this.config.title);
    }
    if(this.config.content) {
      this.config.content = this.multiLangPipe.transform(this.config.content);
    }
  }
    
}
